import { generateClient } from "aws-amplify/api";

let client = null;

export function getApiClient() {
  if (!client) {
    client = generateClient();
  }
  return client;
}

export async function graphqlRequest(query, variables = {}) {
  const apiClient = getApiClient();
  const result = await apiClient.graphql({ query, variables });
  const key = Object.keys(result.data)[0];
  const raw = result.data[key];
  if (typeof raw === "string") {
    return JSON.parse(raw);
  }
  return raw;
}
